import { render } from "./RelatedItem.vue?vue&type=template&id=08e30c41&scoped=true"
import script from "./RelatedItem.vue?vue&type=script&lang=js"
export * from "./RelatedItem.vue?vue&type=script&lang=js"

import "./RelatedItem.vue?vue&type=style&index=0&id=08e30c41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e30c41"]])

export default __exports__